import { toast } from "react-toastify";

import {
  DeleteAgenticLogicRuleVersionRequestPathParamsType,
  DeleteAgenticLogicRuleVersionResponseBodyType,
} from "@intelligems/ig-types";
import { getMutationErrorMessage } from "@src/queryClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const deleteAgenticLogicRuleVersion = async (
  payload: ApiRequest<
    unknown,
    DeleteAgenticLogicRuleVersionRequestPathParamsType
  >
) => {
  const resp = await api.delete<DeleteAgenticLogicRuleVersionResponseBodyType>(
    `/v2/agentic-logic/rules/${payload.pathParams.ruleId}/versions/${payload.pathParams.version}`
  );
  return resp.data;
};

export const useDeleteAgenticLogicRuleVersion = () => {
  const queryClient = useQueryClient();

  return useMutation<
    DeleteAgenticLogicRuleVersionResponseBodyType,
    Error,
    ApiRequest<unknown, DeleteAgenticLogicRuleVersionRequestPathParamsType>,
    unknown
  >({
    mutationFn: async (data) => deleteAgenticLogicRuleVersion(data),
    onSuccess: async (_data, payload) => {
      const { ruleId } = payload.pathParams;
      await queryClient.invalidateQueries({
        queryKey: agenticLogicKeys.versions(ruleId),
      });
      await queryClient.invalidateQueries({
        queryKey: agenticLogicKeys.rule(ruleId),
      });
    },
    onError: (error) => {
      const errorDetail = getMutationErrorMessage(error);
      toast.error(
        `Failed to delete version${errorDetail ? `. ${errorDetail}` : ""}`
      );
    },
  });
};
